import { combineReducers } from 'redux'
import { factoryReducer as createFactoryReducer, flattenStringMap } from '../../../../reducers/utils'
import { actions, factoryActions, pages } from './constants'

const data = (state = [], { type, payload }) => {
  switch (type) {
    case actions.INITIALIZE:
      return payload.data

    case actions.FETCH_SUCCESS:
      return payload.data

    case actions.FETCH_FAILURE:
      return []

    default:
      return state
  }
}

const initialState = {
  activePage: pages.operations,
  fetching: false,
  nominalFlag: 1,
  activeOperationsFlag: 1,
}

const ui = (state = initialState, { type, payload }) => {
  switch (type) {
    case actions.SWITCH_PAGE:
      return {
        ...state,
        activePage: payload.page,
      }

    case actions.FETCH:
      return {
        ...state,
        fetching: true,
      }

    case actions.CHANGE_NOMINAL:
      return {
        ...state,
        nominalFlag: payload.nominalFlag,
      }

    case actions.CHANGE_ACTIVE_OPERATIONS_FLAG:
      return {
        ...state,
        activeOperationsFlag: payload.activeOperationsFlag,
      }

    case actions.FETCH_SUCCESS:
    case actions.FETCH_FAILURE:
      return {
        ...state,
        fetching: false,
      }

    default:
      return state
  }
}

const combinedReducer = combineReducers({
  ui,
  data,
})

export default createFactoryReducer(
//@ts-ignore
  {
    registerType: actions.INITIALIZE,
    unregisterType: factoryActions.DESTROY,
  },
  flattenStringMap(actions),
  combinedReducer,
  (meta) => meta.ID,
)
